import { Component, OnInit, Inject } from "@angular/core";
// import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { ItineraryService } from "../itinerary.service";
import { UserService } from "../../pages/com.usblick.common/auth/user.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { CarouselConfig } from "ngx-bootstrap/carousel";
import { setting } from "../../../../setting";

@Component({
  selector: "usb-modal-sync-product",
  templateUrl: "./modal-sync-product.component.html",
  providers: [
    {
      provide: CarouselConfig,
      useValue: {
        interval: 2500,
        noPause: false,
        showIndicators: false,

      },
    },
  ],
  styleUrls: ["./modal-sync-product.component.scss"],
})
export class ModalSyncProductComponent implements OnInit {
  selectedAgency: any;
  clientSetting: any;
  bookingRouteUpdate: string;
  authRouteUpdate: string;
  urlSafe: SafeResourceUrl;
  children = 0;
  adults = 0;
  data: any;
  images: any = [
    "assets/img/app/loader-images/load1.jpg",
    "assets/img/app/loader-images/load2.jpg",
    "assets/img/app/loader-images/load3.jpg",
  ];

  slides = [
    { image: "assets/img/app/loader-images/load1.jpg", text: "First" },
    { image: "assets/img/app/loader-images/load2.jpg", text: "Second" },
    { image: "assets/img/app/loader-images/load2.jpg", text: "Third" },
  ];
  noWrapSlides = false;
  showIndicator = true;

  constructor(
    public userService: UserService,
    @Inject(MAT_DIALOG_DATA) public item: any,
    public dialogRef: MatDialogRef<ModalSyncProductComponent>,
    public sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    console.log(this.item)
    this.bookingRouteUpdate = setting.apiStorageBooking;
    this.authRouteUpdate = setting.routeUploadFile;
    this.selectedAgency = JSON.parse(localStorage.getItem("selectedAgency"));
    this.clientSetting = JSON.parse(localStorage.getItem(setting.name));

  }

  closeModal(): void {
    this.dialogRef.close();
  }

  get imageSync(): string {
    if(this.bookingRouteUpdate === this.selectedAgency.imagen_logotype) {
      return `${this.authRouteUpdate}${this.clientSetting.logo_path_one}`;
    } else {
      return `${this.bookingRouteUpdate}${this.selectedAgency.imagen_logotype}`
    }

  }
}
